import { Pool } from "../../utils/Pool";
const className = "SaveCmd";
export class SaveCmd {
    static create() {
        return Pool.getItemByClass(className, SaveCmd);
    }
    recover() {
        Pool.recover(className, this);
    }
    run(runner) {
        runner.save();
    }
    get cmdID() {
        return SaveCmd.ID;
    }
}
SaveCmd.ID = className;
